export default __webpack_public_path__ + "static/media/deep_roots_taylor_allison.9c0988c0.jpg";